export default ['#', '##', '###', '####', '## ###', '### ###', '# ### ###', '## ### ###'];